import { ShiftReportPage } from "./ShiftReportPage";

export const ShiftReport = () => {
	return <ShiftReportPage />;
};
